var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"pages__page-box",class:{
    'pages__page-box--active': _vm.active,
    'pages__page-box--loading': _vm.loading
  },on:{"click":function($event){return _vm.$emit('click')}}},[_c('p',{staticClass:"large-medium"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }